const TokensConstants = {
  SET_VISIBLE_RANGE: 'WAL_SET_VISIBLE_RANGE',
  REFRESH: 'WAL_REFRESH',
  GET: 'WAL_GET',
  GET_SUCCESS: 'WAL_GET_SUCCESS',
  GET_FAIL: 'WAL_GET_FAIL',
  RELOAD: 'WAL_RELOAD',
  SET_FILTER: 'WAL_SET_FILTER',
  ACTIVATE_FILTER: 'WAL_ACTIVATE_FILTER',
  SET_ADVANCED_FILTER: 'WAL_SET_ADVANCED_FILTER',
  SET_SORTORDER: 'WAL_SET_SORTORDER',
  MODIFY_SELECTION: 'WAL_MODIFY_SELECTION',
  ALLOW_MULTI_SELECT: 'WAL_ALLOW_MULTI_SELECT',
  REMOVE_SUCCESS: 'WAL_REMOVE_SUCCESS',
  SAVE_SUCCESS: 'WAL_SAVE_SUCCESS',
  ENSURE_SELECTION_IS_VISIBLE: 'WAL_ENSURE_SELECTION_IS_VISIBLE',
  CLEAR: 'WAL_CLEAR',
  UPDATE: 'WAL_UPDATE',
  SET_SELECTION: 'WAL_SET_SELECTION',
  OPEN: 'WAL_OPEN',
  GET_FOR_OPEN_SUCCESS: 'WAL_GET_FOR_OPEN_SUCCESS',
  GET_BY_ID_SUCCESS: 'WAL_GET_BY_ID_SUCCESS',
  FIND_SUCCESS: 'WAL_FIND_SUCCESS',

  CREATE_FAIL: 'WAL_TOKENS_CREATE_FAIL',
  CREATE_SUCCESS: 'WAL_TOKENS_CREATE_SUCCESS',
  SHOW_COPY_BUTTON: 'WAL_TOKENS_SHOW_COPY_BUTTON',
  SHOW_CLIPBOARDMSG: 'WAL_TOKENS_SHOW_CLIPBOARDMSG',
  HIDE_CLIPBOARDMSG: 'WAL_TOKENS_HIDE_CLIPBOARDMSG',
  REMOVE_FAIL: 'WAL_TOKENS_REMOVE_FAIL',
  UPDATE_FAIL: 'WAL_TOKENS_UPDATE_FAIL',
  UPDATE_SUCCESS: 'WAL_TOKENS_UPDATE_SUCCESS',
  GET_SETTINGS_SUCCESS: 'WAL_TOKENS_GET_SETTINGS_SUCCESS',
  GET_SETTINGS_FAIL: 'WAL_TOKENS_GET_SETTINGS_FAIL',
  NEEDS_CONFIRM: 'WAL_TOKENS_NEEDS_CONFIRM',
  CLOSE_DETAILS: 'WAL_TOKENS_CLOSE_DETAILS'
};

export default TokensConstants;
